import { c as _c } from "react/compiler-runtime";
import React from "react";
import PrimaryButton from "@/components/utils/button/PrimaryButton";
interface WaveLeaderboardDefaultEmptyStateProps {
  readonly onCreateDrop?: (() => void) | undefined;
  readonly canCreateDrop: boolean;
  readonly dropRestrictionMessage: string | null;
  readonly createDropLabel?: string | undefined;
  readonly emptyTitle?: string | undefined;
  readonly emptyDescription?: string | undefined;
}
export const WaveLeaderboardDefaultEmptyState: React.FC<WaveLeaderboardDefaultEmptyStateProps> = t0 => {
  const $ = _c(16);
  const {
    onCreateDrop,
    canCreateDrop,
    dropRestrictionMessage,
    createDropLabel: t1,
    emptyTitle: t2,
    emptyDescription: t3
  } = t0;
  const createDropLabel = t1 === undefined ? "Drop" : t1;
  const emptyTitle = t2 === undefined ? "No drops to show" : t2;
  const emptyDescription = t3 === undefined ? "Be the first to create a drop in this wave" : t3;
  let t4;
  if ($[0] !== emptyTitle) {
    t4 = <h3 className="tw-mb-2 tw-text-xl tw-font-medium tw-text-iron-400">{emptyTitle}</h3>;
    $[0] = emptyTitle;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== emptyDescription) {
    t5 = <p className="tw-mb-4 tw-text-iron-500">{emptyDescription}</p>;
    $[2] = emptyDescription;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== canCreateDrop || $[5] !== createDropLabel || $[6] !== onCreateDrop) {
    t6 = onCreateDrop && <PrimaryButton loading={false} disabled={!canCreateDrop} onClicked={onCreateDrop} padding="tw-px-4 tw-py-2"><svg className="-tw-ml-1 tw-h-4 tw-w-4 tw-flex-shrink-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path fillRule="evenodd" d="M12 3.75a.75.75 0 01.75.75v6.75h6.75a.75.75 0 010 1.5h-6.75v6.75a.75.75 0 01-1.5 0v-6.75H4.5a.75.75 0 010-1.5h6.75V4.5a.75.75 0 01.75-.75z" clipRule="evenodd" /></svg><span>{createDropLabel}</span></PrimaryButton>;
    $[4] = canCreateDrop;
    $[5] = createDropLabel;
    $[6] = onCreateDrop;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== canCreateDrop || $[9] !== dropRestrictionMessage) {
    t7 = !canCreateDrop && dropRestrictionMessage && <p className="tw-mt-3 tw-text-xs tw-text-iron-500">{dropRestrictionMessage}</p>;
    $[8] = canCreateDrop;
    $[9] = dropRestrictionMessage;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t4 || $[12] !== t5 || $[13] !== t6 || $[14] !== t7) {
    t8 = <div className="tw-flex tw-h-full tw-flex-col tw-items-center tw-justify-center tw-rounded-lg tw-bg-iron-950 tw-p-8 tw-text-center">{t4}{t5}{t6}{t7}</div>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};